import { Page, PageFace } from 'ui/components/Page'
import { Panel, PanelFace } from 'ui/components/Panel'
import { ReportBreadcrumbs } from '~bank-reports/components'

import { Actions } from './components/Actions'
import { Filter } from './components/Filter'
import { Table } from './components/Table'
import { useSiteAuditDocumentsReportContext } from './context/SiteAuditDocumentsReportContext'
import { SiteAuditDocumentsReportContextProvider } from './context/SiteAuditDocumentsReportProvider'

const SiteAuditDocumentsReportPage = () => {
  const { data } = useSiteAuditDocumentsReportContext()

  return (
    <Page face={PageFace.PRIMARY} title={<ReportBreadcrumbs title={data.title} />} actions={<Actions />}>
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <Table />
      </Panel>
    </Page>
  )
}

const SiteAuditDocumentsReport = () => (
  <SiteAuditDocumentsReportContextProvider>
    <SiteAuditDocumentsReportPage />
  </SiteAuditDocumentsReportContextProvider>
)

export default SiteAuditDocumentsReport
